import React, { useState } from "react";
import Banner from "../Component/donation.png";
import QrCode from "../Component/QR-Code.jpg";
import "./DonationPage.css"; // ⭐ CSS file import karein

function DonationPage() {
  const [popupImage, setPopupImage] = useState(null);

  return (
    <div className="donate-page-wrapper">
      {/* HERO BANNER */}
      <div className="donate-hero-banner">
        <img src={Banner} alt="Donation Banner" className="donate-hero-img" />
        <div className="donate-hero-overlay"></div>
        <div className="donate-hero-content">
          <h1>Support CPIT Educational Trust</h1>
          <p>Empowering Youth • Skill Development • Social Upliftment</p>
        </div>
      </div>

      {/* CONTENT SECTION */}
      <div className="donate-page-content">
        <h2 className="donate-content-title">CPIT (Career Point of Information Technology)</h2>
        <p className="donate-content-text">
          CPIT Educational Trust has been working for skill development,
          technical education, social upliftment, and empowering youth through
          various training and awareness programs.
        </p>

        <div className="donate-feature-box">
          <ul className="donate-feature-list">
            <li className="donate-feature-item">✔ Free skill development programs</li>
            <li className="donate-feature-item">✔ Education support in rural & backward areas</li>
            <li className="donate-feature-item">✔ Women empowerment & digital literacy</li>
            <li className="donate-feature-item">✔ Social awareness & environmental campaigns</li>
          </ul>
        </div>

        <p className="donate-thank-you">
          ❤️ Your support helps us change lives. Thank you!
        </p>
      </div>

      {/* PAYMENT SECTION - SINGLE ROW */}
      <div className="donate-payment-section">
        <h2 className="donate-payment-title">Donate Now</h2>
        
        <div className="donate-payment-row">
          {/* QR CODE */}
          <div className="donate-qr-container">
            <h3 className="donate-section-subtitle">Scan QR Code</h3>
            <img
              src={QrCode}
              alt="CPIT QR"
              className="donate-qr-code"
              onClick={() => setPopupImage(QrCode)}
            />
            <p className="donate-tap-msg">Click to enlarge</p>
          </div>

          {/* BANK DETAILS */}
          <div className="donate-bank-container">
            <h3 className="donate-section-subtitle">Bank Transfer</h3>
            <div className="donate-account-box" onClick={() => setPopupImage("account")}>
              <p className="donate-bank-detail"><strong>Account Number:</strong> 090605002617</p>
              <p className="donate-bank-detail"><strong>Account Holder Name:</strong><br />CAREER POINT OF INFORMATION TECHNOLOGY CPIT EDUCATIONAL TRUST</p>
              <p className="donate-bank-detail"><strong>IFSC Code:</strong> ICIC0000906</p>
              <p className="donate-bank-detail"><strong>Bank Name:</strong> ICICI Bank</p>
              <p className="donate-tap-msg-2">Click to enlarge</p>
            </div>
          </div>
        </div>
      </div>

      {/* POPUP MODAL */}
      {popupImage && (
        <div className="donate-popup" onClick={() => setPopupImage(null)}>
          <div className="donate-popup-content" onClick={(e) => e.stopPropagation()}>
            {popupImage === "account" ? (
              <div className="donate-popup-account">
                <h2 className="donate-popup-title">Bank Details</h2>
                <p className="donate-popup-detail"><strong>Account Number:</strong> 090605002617</p>
                <p className="donate-popup-detail"><strong>Account Holder:</strong><br />CAREER POINT OF INFORMATION TECHNOLOGY CPIT EDUCATIONAL TRUST</p>
                <p className="donate-popup-detail"><strong>IFSC Code:</strong> ICIC0000906</p>
                <p className="donate-popup-detail"><strong>Bank:</strong> ICICI Bank</p>
              </div>
            ) : (
              <img src={popupImage} alt="Zoomed QR" className="donate-popup-image" />
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default DonationPage;